module.exports = "/_next/static/images/increased-productivity-71c4a6b896cedabe6276d15acdce84b1.svg";